import { useDispatch } from "react-redux";

import { useSelector } from "../store";
import { Quotas, pomeriumApi, useGetQuotasQuery } from "../store/pomeriumApi";

function useQuota(quota: keyof Quotas) {
  const dispatch = useDispatch();
  const organizationId = useSelector((state) => state.current.organizationId);
  const clusterId = useSelector((state) => state.current.clusterId);

  const { data, isLoading } = useGetQuotasQuery(
    {
      organizationId,
      namespaceId: clusterId || undefined,
    },
    {
      skip: !organizationId,
    },
  );

  function refetch() {
    dispatch(pomeriumApi.util.invalidateTags(["quota"]));
  }

  return {
    count: data?.counts?.[quota] || 0,
    limit: data?.limits?.[quota] || 0,
    refetch,
    isLoading,
  };
}
export default useQuota;
